import { storeKeys } from "./stores";

export function StoreSelector({
  selectedStores,
  setCollections,
}: {
  selectedStores: any[];
  setCollections: (store: string) => void;
}) {
  return (
    <div>
      {storeKeys.map(function (store) {
        return (
          <div
            key={store.id}
            className="w-full flex flex-row items-center space-x-4 h-12 p-2"
          >
            <input
              id={store.id}
              name={store.id}
              type="checkbox"
              checked={selectedStores.includes(store.id)}
              className="focus:ring-dustyrose h-4 w-4 text-dustyrose border-gray-300 rounded"
              onChange={() => setCollections(store.id)}
            />
            <p>{store.label}</p>
          </div>
        );
      })}
    </div>
  );
}
